module.exports = __webpack_public_path__ + "img/homeabout.7e1d5329.png";